import AnchorCarousel from "@components/Modules/AnchorCarousel/AnchorCarousel";
import { ReactNode } from "react";

import styles from "../homelayout.module.css";
import { HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
};

export default function HomeAnchorCarousel({ data }: Props): ReactNode {
  const carouselItems = [
    data.AnchorBlockProps,
    ...data.latestArticle.items,
  ].filter((el) => el !== undefined);

  if (carouselItems.length === 0) return null;

  return (
    <div className={styles.homeAnchorCarousel}>
      <AnchorCarousel data={carouselItems} />
    </div>
  );
}
